import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './route';


Vue.config.productionTip = false;

Vue.prototype.$events = [
        {
          image: '/images/event-einstein.jpg',
          title: 'EINSTEIN<br>ON THE<br><span>BEACH</span>',
          date: 'Du 11 au 18/09 2019',
          ballet: 0,
          opera: 1,
          link: '/pdf/Einstein-on-the-beach.pdf',
          resa: 'https://billetterie.gtg.ch/selection/event/date?productId=1415791639'
        },{
          image: '/images/event-aida.jpg',
          title: 'AIDA',
          date: 'Du 11 au 22/10 2019',
          ballet: 0,
          opera: 1,
          link: '/pdf/Aida.pdf',
          resa: 'https://billetterie.gtg.ch/selection/event/date?productId=1415791648'
        },{
          image: '/images/event-orfeo.jpg',
          title: 'ORFEO',
          date: 'Du 28 au 29/10 2019',
          ballet: 0,
          opera: 1,
          link: '/pdf/Orfeo.pdf'
        },{
          image: '/images/event-ballet1.jpg',
          title: 'MINIMAL<br> <span>MAXIMAL</span>',
          date: 'Du 10 au 17/11 2019',
          ballet: 1,
          opera: 0,
          link: '/pdf/Minimal-Maximal.pdf'
        },{
          image: '/images/event-indes.jpg',
          title: 'LES INDES<br><span>GALANTES</span>',
          date: 'Du 13 au 29/12 2019',
          ballet: 1,
          opera: 1,
          link: '/pdf/Les-indes-Galantes.pdf'
        },{
          image: '/images/event-entfuhrung.jpg',
          title: 'Die<br> Entführung<br><span>AUS DEM<br>SERAIL</span>',
          date: 'Du 22/01 au 02/02 2020',
          ballet: 0,
          opera: 1,
          link: '/pdf/Die-entfuhrung-aus-dem-serail.pdf'
        },{
          image: '/images/event-brandeburg.jpg',
          title: 'The Six<br> Brandenburg<br> <span>Concertos</span>',
          date: 'Du 20 au 23/02 2020',
          ballet: 1,
          opera: 0,
          link: '/pdf/The-six-brandeburg-Concertos.pdf'
        },{
          image: '/images/event-huguenots.jpg',
          title: 'LES<br><span>HUGUENOTS</span>',
          date: 'Du 26/02 au 08/03 2020',
          ballet: 0,
          opera: 1,
          link: '/pdf/Les-Huguenots.pdf'
        },{
          image: '/images/event-voyage.jpg',
          title: 'VOYAGE<br>VERS<br><span>L’ESPOIR</span>',
          date: 'Du 30/03 au 08/04 2020',
          ballet: 0,
          opera: 1,
          link: '/pdf/Voyage-vers-l-espoir.pdf'
        },{
          image: '/images/event-cenerentola.jpg',
          title: 'La<br><span>Cenerentola</span>',
          date: 'Du 04 au 20/05 2020',
          ballet: 0,
          opera: 1,
          link: '/pdf/La-cenerentola.pdf'
        },{
          image: '/images/event-cqnreste.jpg',
          title: 'Ce qu\'il<br> <span>nous reste</span>',
          date: 'Du 06 au 14/06 2020',
          ballet: 1,
          opera: 0,
          link: '/pdf/Ce-qu-il-nous-reste.pdf'
        },{
          image: '/images/event-francois.jpg',
          title: 'SAINT<br>FRANÇOIS<br><span>D’ASSISE</span>',
          date: 'Du 26/06 au 05/07 2020',
          ballet: 0,
          opera: 1,
          link: '/pdf/StFrancois-d-assise.pdf'
        }
      ]


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
